"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryResourceSection = void 0;
const react_1 = __importDefault(require("react"));
const dateUtils_1 = require("../../../utils/dateUtils");
const IconCalendar_1 = require("../../icons/IconCalendar");
const IconTime_1 = require("../../icons/IconTime");
const NumericFormatTwoDecimals_1 = require("../../numeric-format/NumericFormatTwoDecimals");
const SummaryResourceSection = (props) => {
    const resourceItem = props.booking.resourceItem;
    const duration = resourceItem.quantity;
    let formattedDuration;
    if (duration === 1) {
        formattedDuration = `1 Stunde`;
    }
    else {
        formattedDuration = `${duration} Stunden`;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("td", { className: "pb-0", colSpan: 3 },
                resourceItem.type,
                " \u00AB",
                resourceItem.title,
                "\u00BB")),
        react_1.default.createElement("tr", null,
            react_1.default.createElement("td", { className: "pt-0 small" },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(IconCalendar_1.IconCalendar, null),
                    " ",
                    (0, dateUtils_1.formatDate)(props.booking.start),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(IconTime_1.IconTime, null),
                    " ",
                    (0, dateUtils_1.formatTime)(props.booking.start),
                    " -",
                    " ",
                    (0, dateUtils_1.formatTime)(props.booking.end))),
            react_1.default.createElement("td", { className: "pt-0 small" }, formattedDuration),
            react_1.default.createElement("td", { className: "pt-0 text-right small" }, resourceItem.price && (react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: resourceItem.price })))),
        resourceItem.discount && (react_1.default.createElement("tr", { className: "discount" },
            react_1.default.createElement("td", { className: "pt-0 small" },
                "\u2517\u2501 ",
                resourceItem.discount.title),
            react_1.default.createElement("td", { className: "pt-0 small" }, resourceItem.discount.percent
                ? `(${resourceItem.discount.percent}%)`
                : ""),
            react_1.default.createElement("td", { className: "pt-0 text-right small" },
                "-",
                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: resourceItem.discount.calc(resourceItem.price) }))))));
};
exports.SummaryResourceSection = SummaryResourceSection;
